// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.CustomField = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.CustomField = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var CustomField = _exports.CustomField = function CustomField(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.16406 1.49609H8.10901C9.15277 1.49609 9.9989 2.34225 9.9989 3.38603C9.9989 2.34225 10.845 1.49609 11.8888 1.49609H12.8337",
      stroke: "#212B36",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.99982 17.5593V3.38477",
      stroke: "#212B36",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12.8337 18.5052H11.8888C10.845 18.5052 9.9989 17.659 9.9989 16.6152C9.9989 17.659 9.15277 18.5052 8.10901 18.5052H7.16406",
      stroke: "#212B36",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.16382 15.6697H3.38403C2.34027 15.6697 1.49414 14.8235 1.49414 13.7798V6.22002C1.49414 5.17623 2.34027 4.33008 3.38403 4.33008H7.16382",
      stroke: "#212B36",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12.834 15.6702H16.6138C17.6575 15.6702 18.5037 14.824 18.5037 13.7803V6.2205C18.5037 5.17672 17.6575 4.33057 16.6138 4.33057H12.834",
      stroke: "#212B36",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }));
  };
});
